import json from './sprite.js';

export default {
    handle: 'es_SPT15-Playground',
    label: 'es_SPT15-Playground',
    json,
};
